import { render, staticRenderFns } from "./MSOMenuBase.vue?vue&type=template&id=4116acd6&"
import script from "./MSOMenuBase.vue?vue&type=script&lang=js&"
export * from "./MSOMenuBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports